.alert {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}

.alert :global(.MuiAlert-icon) {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
}

.iconContainer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d9534f;
  flex-shrink: 0;
}

.iconContainer svg {
  stroke: currentColor;
  fill: none;
}

.x {
  position: absolute;
  stroke: currentColor;
  animation: xRotate 2s ease-in-out infinite;
}

.animated {
  animation: float 2s ease-in-out infinite;
}

.animated .x {
  animation: xRotate 2s ease-in-out infinite, float 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes xRotate {
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(15deg);
  }
}
